import React from 'react'
import { Button, Form, Input, Modal, message } from 'antd'
import {
  createAdminStep,
  updateAdminStep,
  deleteAdminStep,
} from '../../../../features/poll/api-admin'

const { TextArea } = Input

interface StepModalProps {
  open: boolean
  quizId: string
  step: any
  onCancel: () => void
  onOk: () => void
}

export default function StepModal({ open, quizId, step, onCancel, onOk }: StepModalProps) {
  const [form] = Form.useForm()
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    if (open) {
      form.setFieldsValue({
        title: step?.title || '',
        description: step?.description || '',
      })
    }
  }, [open, step, form])

  const handleSave = async () => {
    try {
      setLoading(true)
      const values = await form.validateFields()

      if (step?.id) {
        await updateAdminStep(quizId, step.id, values)
        message.success('Шаг обновлён')
      } else {
        await createAdminStep(quizId, values)
        message.success('Шаг создан')
      }

      onOk()
    } catch (e: any) {
      message.error(e?.message || 'Не удалось сохранить шаг')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      title={step ? 'Редактировать шаг' : 'Создать шаг'}
      open={open}
      onOk={handleSave}
      onCancel={onCancel}
      confirmLoading={loading}
      destroyOnHidden
    >
      <Form form={form} layout="vertical">
        <Form.Item name="title" label="Название шага" rules={[{ required: true }]}>
          <Input placeholder="Например: Шаг 1" />
        </Form.Item>
        <Form.Item name="description" label="Описание шага">
          <TextArea rows={3} placeholder="Необязательное описание шага" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
